import styled, { css } from 'styled-components';
import { P as PortalComponent } from '../Portal/PortalComponent-VEfCtCOY.js';

const TRANSITION_CLASSNAME_PREFIX = 'popper-surface-transition';
const PopoverTrigger = /*#__PURE__*/styled.span.withConfig({
  componentId: "sc-storm-ui-40026394__sc-4z7sux-0"
})(["display:inline-block;width:", ";"], ({
  $fullWidth
}) => $fullWidth ? '100%' : 'auto');
PopoverTrigger.displayName = 'PopoverTrigger';
const PopoverSurface = /*#__PURE__*/styled('div').withConfig({
  componentId: "sc-storm-ui-40026394__sc-4z7sux-1"
})(["", ";border-radius:", ";box-shadow:", ";z-index:", ";@media (prefers-reduced-motion:no-preference){transition:opacity ", "ms ease-in-out;}opacity:0;&&.", "-appear{opacity:0;}&&.", "-appear-active{opacity:1;}&&.", "-appear-done{opacity:1;}&&.", "-enter{opacity:1;}&&.", "-enter-active{opacity:1;}&&.", "-enter-done{opacity:1;}&&.", "-exit{opacity:0;}&&.", "-exit-active{opacity:0;}&&.", "-exit-done{opacity:0;}", " > &&{width:max-content;}"], ({
  theme,
  $variant
}) => {
  if ($variant === 'spotlight') {
    return css(["background-color:", ";border:none;"], theme.support.backgroundColor.spotlightBold);
  }
  if ($variant === 'inverted') {
    return css(["background-color:", ";border:none;"], theme.surface.inverted);
  }
  return css(["background-color:", ";border:", ";"], theme.surface.container.default, theme.border.subtle.default);
}, ({
  theme
}) => theme.border.radius.large, ({
  theme
}) => theme.elevation.shadow.overlay, ({
  theme
}) => theme.elevation.zIndex.layer3, ({
  $transitionDuration
}) => $transitionDuration, TRANSITION_CLASSNAME_PREFIX, TRANSITION_CLASSNAME_PREFIX, TRANSITION_CLASSNAME_PREFIX, TRANSITION_CLASSNAME_PREFIX, TRANSITION_CLASSNAME_PREFIX, TRANSITION_CLASSNAME_PREFIX, TRANSITION_CLASSNAME_PREFIX, TRANSITION_CLASSNAME_PREFIX, TRANSITION_CLASSNAME_PREFIX, /* only apply `width: max-content;` to Popovers that are children of Popovers */
PortalComponent);
PopoverSurface.displayName = 'PopoverSurface';
const PopperArrow = /*#__PURE__*/styled('div').withConfig({
  componentId: "sc-storm-ui-40026394__sc-4z7sux-2"
})(["position:absolute;width:10px;height:10px;z-index:-1;::after{content:\" \";position:absolute;/*! @noflip */ transform:rotate(45deg);width:10px;height:10px;", ";}/*! @noflip */ *[data-popper-placement^=\"right\"] > &{/*! @noflip */ left:0px;}/*! @noflip */ *[data-popper-placement^=\"right\"] > &::before{/*! @noflip */ left:-6px;}/*! @noflip */ *[data-popper-placement^=\"right\"] > &::after{/*! @noflip */ left:-4px;/*! @noflip */ box-shadow:-1px 1px 2px -1px rgba(35,47,63,0.3);}/*! @noflip */ *[data-popper-placement^=\"left\"] > &{/*! @noflip */ right:0px;}/*! @noflip */ *[data-popper-placement^=\"left\"] > &::before{/*! @noflip */ right:-6px;}/*! @noflip */ *[data-popper-placement^=\"left\"] > &::after{/*! @noflip */ right:-4px;/*! @noflip */ box-shadow:1px -1px 2px -1px rgba(35,47,63,0.3);}*[data-popper-placement^=\"top\"] > &{bottom:0px;}*[data-popper-placement^=\"top\"] > &::before{bottom:-6px;}*[data-popper-placement^=\"top\"] > &::after{bottom:-4px;/*! @noflip */ box-shadow:1px 1px 2px -1px rgba(35,47,63,0.3);}*[data-popper-placement^=\"bottom\"] > &{top:0px;}*[data-popper-placement^=\"bottom\"] > &::before{top:-6px;}*[data-popper-placement^=\"bottom\"] > &::after{top:-4px;/*! @noflip */ box-shadow:-1px -1px 2px -1px rgba(35,47,63,0.3);}"], ({
  theme,
  $variant
}) => {
  if ($variant === 'spotlight') {
    return css(["background-color:", ";"], theme.support.backgroundColor.spotlightBold);
  }
  if ($variant === 'inverted') {
    return css(["background-color:", ";"], theme.surface.inverted);
  }
  return `background-color: ${theme.surface.container.default}`;
});

export { PopoverTrigger as P, TRANSITION_CLASSNAME_PREFIX as T, PopoverSurface as a, PopperArrow as b };
//# sourceMappingURL=Popover.styles-Dy2vgBOK.js.map
